const bn128 = require('./lib/index.asm.js')

module.exports = bn128


//////////////////
// WEBPACK FOOTER
// ./node_modules/ganache-core/node_modules/rustbn.js/index.js
// module id = 75
// module chunks = 0